import React from 'react'
import { Message, Segment } from 'semantic-ui-react'
import PropTypes from "prop-types";

const Panel = ({ header, subheader, children, overflow, menu, icon, segments, ...rest }) => {
    return (
            <Segment.Group style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                {(header || subheader) && <Message icon={icon} header={header} content={subheader} attached="top" />}
                {menu}
                <Segment attached={(header || subheader) ? "bottom" : undefined} style={{ flex: 1, overflow: overflow || "inherit" }} {...rest}>
                    {children}
                </Segment>
                {segments}
            </Segment.Group>
    )
}
Panel.propTypes = {
    header: PropTypes.any,
    subheader: PropTypes.any,
    children: PropTypes.any,
    overflow: PropTypes.string,
    menu: PropTypes.element,
    icon: PropTypes.any,
    segments: PropTypes.array
}
export default Panel